module.exports = __webpack_public_path__ + "static/gillfor-logo-aea6f39c841f914fe0f53e193581c456.jpg";